import { SpinBoundaryStartActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { WinSequencePresenter } from "../win/sequence/WinSequencePresenter";

/**
 * Every spin (the base spin AND each free spin inside the round) tears the previous spin down and starts the next:
 * free spins never run the click-time pre-spin, so the boundary is their only spin driver. The title's spin cycle
 * runs (its teardown and the reel scroll), the win sequence restarts (the first win takes the first-win beat again),
 * the title's own per-spin reset runs, and the meter resets (decision 46). The idle win re-show stops first, so it never
 * dims or strokes the next spin's grid (decision 65).
 */
export function createSpinCyclePlugin(deps: {
  /** The title's per-spin teardown and reel start, the same the click's pre-spin runs. */
  beginSpinCycle: () => void;
  presenter: WinSequencePresenter;
  /** The title's own state per spin (slot-cannon: the cannon's fire-sound ladder starts again). */
  onSpinStart?: () => void;
}): ReplayPlugin {
  return {
    name: "spin-cycle",
    actionHandlers: [
      new SpinBoundaryStartActionHandler(async () => {
        deps.presenter.stopWinCycle();
        deps.beginSpinCycle();
        deps.presenter.resetWinHighlightSequence();
        deps.onSpinStart?.();
        deps.presenter.hideWinMeterForNewSpin();
      }),
    ],
  };
}
